import { useScrollLock } from "@/hooks/useScrollLock";
import { Grid, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  UserAgreementContentEn,
  UserAgreementContentZh,
} from "./UserAgreementContent";
import "./UserAgreementModal.css";

interface UserAgreementModalProps {
  open: boolean;
  onClose: () => void;
}

export const UserAgreementModal: React.FC<UserAgreementModalProps> = ({
  open,
  onClose,
}) => {
  const { t, i18n } = useTranslation();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;

  // 判断当前语言是否为英文
  const isEnglish = i18n.language === "en" || i18n.language?.startsWith("en-");

  // 防止移动端滚动穿透
  useScrollLock(open);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <div
          style={{
            fontSize: 20,
            fontWeight: 600,
            color: "#0f172a",
            textAlign: "center",
          }}
        >
          {t("common.modals.user_agreement_title")}
        </div>
      }
      width={isMobile ? "90vw" : 800}
      centered
      rootClassName="user-agreement-modal-custom"
      styles={{
        content: {
          borderRadius: 6,
          overflow: "hidden",
        },
      }}
    >
      <div className="user-agreement-content">
        {isEnglish ? <UserAgreementContentEn /> : <UserAgreementContentZh />}
      </div>
    </Modal>
  );
};

export default UserAgreementModal;
